import { render, staticRenderFns } from "./FormularioMujer.vue?vue&type=template&id=5b20e9ae&scoped=true"
import script from "./FormularioMujer.vue?vue&type=script&lang=js"
export * from "./FormularioMujer.vue?vue&type=script&lang=js"
import style0 from "./FormularioMujer.vue?vue&type=style&index=0&id=5b20e9ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b20e9ae",
  null
  
)

export default component.exports